import React, { useEffect, useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

import { useParams } from 'react-router-dom';

export default function LoginScreen() {
  const { eventId, code } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // On mount: check token + init AppleID
  useEffect(() => {
    // 1) Auto-redirect if already logged in:
    const token = localStorage.getItem('logintoken');
    if (token) {
navigate(`/${eventId}/${code || ''}`, { replace: true });
      return;
    }
const getAppleRedirectURI = () => {
  const origin = window.location.origin;
  if (origin.includes('ngrok-free.app')) {
    return origin;
  } else {
    return 'https://tickets.upass.gr';
  }
};

    // 2) Initialize Apple Sign-In
    if (window.AppleID) {
     window.AppleID.auth.init({
  clientId: 'gr.upass.web',
  scope: 'name email',
  redirectURI: getAppleRedirectURI(),
  usePopup: true,
});
    }
  }, [navigate]);

  // Common backend call
  const handlePostNameAndEmail = async (name, email, type, token = null) => {
    setLoading(true);
    try {
      const payload = { name, email, type };
if (token) payload.token = token;
      const res = await fetch('/oauth.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (data.token) {
        localStorage.setItem('logintoken', data.token);
navigate(`/${eventId}/${code || ''}`, { replace: true });
      } else {
        alert('Login failed. Please try again.');
      }
    } catch (e) {
      console.error(e);
      alert('Login error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // ─── Google Login ───────────────────────────────────────────────────────
  const loginWithGoogle = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        // Fetch user info
        const userInfo = await fetch(
          'https://www.googleapis.com/oauth2/v3/userinfo',
          { headers: { Authorization: `Bearer ${tokenResponse.access_token}` } }
        ).then((r) => r.json());

        handlePostNameAndEmail(
          userInfo.name,
          userInfo.email,
          'g'        );
      } catch (err) {
        console.error(err);
        alert('Google login failed.');
      }
    },
    onError: () => alert('Google login failed.'),
  });

  // ─── Apple Login ────────────────────────────────────────────────────────
  const loginWithApple = async () => {
    setLoading(true);
    try {
      const response = await window.AppleID.auth.signIn();
      const { authorization, user } = response;

      let name = '';
      let email = '';

      if (user) {
        // first-time: response.user is a JSON string
        const u = JSON.parse(user);
        name = `${u.name.firstName || ''} ${u.name.lastName || ''}`.trim();
        email = u.email;
      } else {
        // subsequent logins: decode id_token
        const decoded = jwtDecode(authorization.id_token);
        email = decoded.email;
        name = decoded.name || '';
      }

      handlePostNameAndEmail(name, email, 'a');
    } catch (err) {
      console.error('Apple sign-in error', err);
      alert('Apple login failed.');
      setLoading(false);
    }
  };

  return (
    <div className="container">
      {loading ? (
        <div className="spinner">
          <div className="double-bounce1" />
          <div className="double-bounce2" />
        </div>
      ) : (
        <>
         

          <img
            src="https://upass.gr/logotransparent.png"
            alt="U-Pass Logo"
            className="logo"
          />

          <h1 className="title">Καλωσορίσατε στο U-Pass!</h1>
          <p className="subtitle">
            Τον ευκολότερο τρόπο για να κάνετε<br />
            κρατήσεις και να βρείτε πληροφορίες<br />
            για 50+ μαγαζιά της Αθήνας!
          </p>

          <div className="button-group">
<button className="oauth-button" onClick={() => loginWithGoogle()}>
  <i className="fab fa-google icon" />
  <span>Συνέχεια με Google</span>
</button>

<button className="oauth-button" onClick={loginWithApple}>
  <i className="fab fa-apple icon" />
  <span>Συνέχεια με Apple</span>
</button>

<button
  className="oauth-button"
  onClick={() => navigate(`/login-signup/${eventId}/${code || ''}`)}
>
  <i className="fas fa-envelope icon" />
  <span>Συνέχεια με Email</span>
</button>

          </div>

          <p className="legal">
            Συνεχίζοντας, συμφωνείτε με τους<br />
            <a
              href="https://upass.gr/policy.html"
              target="_blank"
              rel="noreferrer"
            >
              Όρους Χρήσης
            </a>
            .
          </p>
        </>
      )}
    </div>
  );
}
